/*
* Views are screens to show on user interface
* all init functions are initiated here
* @Author STRUCTLOOPER
* */
import React from 'react';
import {Helmet} from 'react-helmet';
import {getStateFromSelector} from "../redux/store";
import {CURRENT_SESSION_STATE_REDUCER} from "../redux/reducers";
import Home from "./home";
import SideBar from "./layouts/sidebar";
// import {setCurrentPageTitle} from "../redux/action";
// import {useDispatch} from "react-redux";

const Application = () => {
    // const ds = useDispatch()
    const {pageTitle, pageName} = getStateFromSelector(CURRENT_SESSION_STATE_REDUCER);
    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <div>
                <Home />
                {/*<SideBar />*/}
            </div>
            {/*<h1>This is {pageName}</h1>*/}
            {/*<button type="button" className="btn btn-primary" onClick={()=>ds(setCurrentPageTitle("Deepak Kumar"))}>Primary</button>*/}
        </>
    );
};

export default Application;